import React from "react"
import App from "../components/App"
import FrontPageContent from "../components/FrontPageContent"
import FrontPageMeta from "../components/FrontPageMeta"
import TopBar from "../components/TopBar"

const IndexPage = () => {
  return (
    <App>
      <TopBar />
      <FrontPageContent isShareOpen={true} isOptionsOpen={false} />
    </App>
  )
}

export const Head = ({ pageContext }) => (
  <FrontPageMeta language={pageContext.language} />
)

export default IndexPage
